import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { configsService } from "../../Services/configs.service";

export default function ValidateEmail() {
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const getEndpointMessage = (payload) => {
    if (!payload) return "";

    if (typeof payload === "string") return payload;

    return (
      payload.friendlyMessage ||
      payload.message ||
      payload.result?.friendlyMessage ||
      payload.result?.message ||
      payload.raw?.friendlyMessage ||
      payload.raw?.message ||
      ""
    );
  };

  const formatMessage = (text) => {
    if (!text) return "";
    return text.replace(/<br\s*\/?>/gi, "\n");
  };

  const params = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);

    let groupId = searchParams.get("groupId");
    let key = searchParams.get("key");

    if (!groupId || !key) {
      const rawHash = window.location.hash || "";
      const [, queryString = ""] = rawHash.split("?");
      const fallbackParams = new URLSearchParams(queryString);

      groupId = groupId || fallbackParams.get("groupId");
      key = key || fallbackParams.get("key");
    }

    return {
      groupId: groupId?.trim() || "",
      key: key?.trim() || "",
    };
  }, [location.search]);

  useEffect(() => {
    const runValidation = async () => {
      if (!params.groupId || !params.key) {
        setStatus("error");
        setMessage("");
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        const response = await configsService.validateEmailConfiguration(params.key);
        const endpointMessage = formatMessage(getEndpointMessage(response));

        if (response?.error) {
          setStatus("error");
          setMessage(endpointMessage);
        } else {
          setStatus("success");
          setMessage(endpointMessage);
        }
      } catch (error) {
        setStatus("error");
        const endpointMessage = formatMessage(getEndpointMessage(error?.response?.data));
        setMessage(endpointMessage);
      } finally {
        setLoading(false);
      }
    };

    runValidation();
  }, [params.groupId, params.key]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "24px",
        backgroundColor: "var(--body-bg, #f4f5f7)",
      }}
    >
      <div
        className="card"
        style={{
          width: "100%",
          maxWidth: "520px",
          padding: "24px",
        }}
      >
        <h4 style={{ marginBottom: "12px" }}>Validação de e-mail</h4>

        {loading ? (
          <p style={{ marginBottom: 0 }}>Validando e-mail, aguarde...</p>
        ) : (
          <>
            <p
              style={{
                marginBottom: "16px",
                whiteSpace: "pre-line",
                color:
                  status === "success" ? "var(--bs-success)" : "var(--bs-danger)",
              }}
            >
              {message}
            </p>
            <Link to="/login" className="btn btn-primary">
              Ir para o login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
